import React from "react";
import ChargebackVolumeChart from "./ChargebackVolumeChart";
import ScoreCard from "./ScoreCard";
import style from "./Chargeback.module.scss";
import ChargebackTabs from "./ChargebackTabs/ChargebackTabs";
import useCommonStore from "../../../../stores/common";

function Chargeback() {
  const expandDetails = useCommonStore((state) => state.expandDetails);

  return (
    <div className={style.chargeback_container}>
      <div className={`${style.charts} ${expandDetails ? style.expanded : ""}`}>
        <ChargebackVolumeChart />
        <ScoreCard />
      </div>
      <ChargebackTabs />
    </div>
  );
}

export default Chargeback;
